import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=41592bbc&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=ts"
export * from "./Insights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41592bbc",
  null
  
)

export default component.exports